// React dependencies
import React, { useState } from 'react';

// External dependencies
import PropTypes from 'prop-types';

// Internal dependencies
import { Divider } from '@material-ui/core';
import MText from '../../../../../components/Common/MText';
import PoiLocation from '../Poi/PoiLocation';
import TagsOthers from '../Poi/TagsOthers';
import PhotoInfo from '../Photos/PhotoInfo';
import PoiButton from '../PoiButton';
import { IsEmpty } from '../../../../../common/checks';

const ReviewStage = (props) => {
  const [selectedPhotoIdx, setSelectedPhotoIdx] = useState(0);
  return (
    <div
      className="mt-4 pt-2 w-100 mx-auto"
      style={{ maxWidth: '95%' }}
    >
      <MText text={`Place of interest${props.selectedPoi ? `: ${props.selectedPoi.name}` : ''}`} className="mb-2" bold size={16} />
      {
        IsEmpty(props.selectedPoi) && (
          <div className="d-flex flex-column">
            <MText className="text-center" size={15} text={props.poiName} />
            <PoiLocation
              address={props.address}
              isCustomAddress={props.isCustomAddress}
              disabled
            />
            <div className="mt-4">
              <TagsOthers
                data={{
                  description: props.description,
                  tags:        props.tags,
                  hours:       props.hours,
                }}
                disabled
              />
            </div>
          </div>
        )
      }

      <Divider />

      <div className="mt-4 mb-3">
        <MText text="Photos" bold size={16} />
      </div>

      <PhotoInfo
        photos={props.photos}
        poiAddress={props.address}
        selectedPhotoIdx={selectedPhotoIdx}
        onSelectedPhotoIdxChange={(idx) => setSelectedPhotoIdx(idx)}
        disabled
      />
      <div className="d-flex justify-content-between align-items-center w-100 mt-5">
        <PoiButton
          text="Back"
          onClick={props.onNavigateToPreviousStage}
        />
        <PoiButton
          text="Submit"
          onClick={props.onSubmit}
        />
      </div>
    </div>
  );
};

ReviewStage.propTypes = {
  poiName:         PropTypes.string.isRequired,
  isCustomAddress: PropTypes.bool.isRequired,
  address:         {
    name:       PropTypes.string,
    postalCode: PropTypes.string,
    lat:        PropTypes.number.isRequired,
    lng:        PropTypes.number.isRequired,
  }.isRequired,
  description: PropTypes.string,
  tags:        PropTypes.arrayOf(PropTypes.string).isRequired,
  hours:       PropTypes.string,
  photos:      PropTypes.arrayOf(PropTypes.shape({
    url:      PropTypes.string.isRequired,
    location: PropTypes.shape({
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired,
    }).isRequired,
    takenOn:     PropTypes.shape({}),
    description: PropTypes.string,
    tags:        PropTypes.arrayOf(PropTypes.string),
  })).isRequired,
  onNavigateToPreviousStage: PropTypes.func.isRequired,
  onSubmit:                  PropTypes.func.isRequired,
  selectedPoi:               PropTypes.shape({
    name: PropTypes.string.isRequired,
  }),
};

ReviewStage.defaultProps = {
  description: '',
  hours:       null,
  selectedPoi: null,
};

export default ReviewStage;
